import { render, staticRenderFns } from "./dicatamenOperativoCz.vue?vue&type=template&id=2bd1df96&scoped=true"
import script from "./dicatamenOperativoCz.vue?vue&type=script&lang=js"
export * from "./dicatamenOperativoCz.vue?vue&type=script&lang=js"
import style0 from "./dicatamenOperativoCz.vue?vue&type=style&index=0&id=2bd1df96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd1df96",
  null
  
)

export default component.exports